import React, { ReactNode } from 'react';
import { Alert, Spin } from 'antd';
import Box from '@components/box/Box';

type Props<T> = {
  error?: any;
  errorDescription?: (error: any) => ReactNode;
  loading: boolean;
  loadingText?: ReactNode;
  data?: T;
  children: (data: T) => ReactNode;
  minHeight?: number;
};

const Loading = <T extends {}>({
  error,
  errorDescription = () => 'Cannot load data',
  loading,
  loadingText = 'Loading data...',
  data,
  children,
  minHeight
}: Props<T>) => {
  return (
    <>
      {error ? (
        <Alert
          type="error"
          message="Error"
          showIcon
          description={errorDescription(error)}
        />
      ) : (
        <Spin spinning={loading}>
          {data ? (
            children(data)
          ) : (
            <Box header={<div style={{ minHeight }}>{loadingText}</div>} />
          )}
        </Spin>
      )}
    </>
  );
};

export default Loading;
